export const closeModal = ({ commit }) => {
    commit('openedModal', null);
    commit('openedModalPayload', null);
};